export default function (state = {income:0}, action) {
    switch (action.type) {
        case 'CHANGE_INCOME_DATA':
            return {
              income: action.income,
            };
            break;


    }
    return state;
}



// WEBPACK FOOTER //
// ./src/config/allReducers/search/incomeReducer.js